import { useCallback } from 'react'

import { useMeUser } from 'features/users/hooks/useMeUser'
import {
  UserLike,
  isAdmin,
  isEditor,
  isViewer,
  hasEditionRole,
  isSuperadmin,
  getRoleInfo,
  isGuest
} from 'features/users/model/user'
import { UserRole } from 'features/users'

export interface UserRolesState {
  user: UserLike | undefined
  userIsSuperadmin: boolean | null
  userIsAdmin: boolean | null
  userIsEditor: boolean | null
  userIsViewer: boolean | null
  userIsGuest: boolean | null
  userHasEditionRole: boolean | null
  shouldShowToUser: (hideFrom: UserRole[]) => boolean
}

function useUserRoles(): UserRolesState {
  const user = useMeUser()
  const { role: userRole } = getRoleInfo(user)
  const userIsAdmin = isAdmin(user)
  const userIsEditor = isEditor(user)
  const userIsViewer = isViewer(user)
  const userHasEditionRole = hasEditionRole(user)
  const userIsSuperadmin = isSuperadmin(user)
  const userIsGuest = isGuest(user)

  const shouldShowToUser = useCallback(
    (hideFrom: UserRole[]) => {
      if (hideFrom) {
        return !hideFrom.some((role) => userRole === role)
      }
      return true
    },
    [userRole]
  )

  return {
    user,
    userIsSuperadmin,
    userIsAdmin,
    userIsEditor,
    userIsViewer,
    userIsGuest,
    userHasEditionRole,
    shouldShowToUser
  }
}

export default useUserRoles
